//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "iconButton",
  props: ["title", "isShowTitle", "onClick", "value"],
  methods: {
    click: function() {
      this.onClick(this.value);
    }
  },
  data() {
    return {
      data: {
        power: {
          className: "iconfont icon-dianyuan",
          name: "电源"
        },
        model: {
          className: "iconfont icon-moshi",
          name: "模式"
        },
        swingFlap: {
          className: "iconfont icon-jiadiansaofeng",
          name: "扫风"
        },
        heating: {
          className: "iconfont icon-icon09",
          name: "制热"
        },
        windDirection: {
          className: "iconfont icon-fengxiang135",
          name: "风向"
        },
        refrigeration: {
          className: "iconfont icon-zhileng",
          name: "制冷"
        },
        airVolume: {
          className: "iconfont icon-fengliang4",
          name: "风量"
        },
        menu: {
          className: "iconfont icon-caidan01",
          name: "菜单"
        },
        signal: {
          className: "iconfont icon-xinhao",
          name: "信号源"
        },
        back: {
          className: "iconfont icon-fanhui",
          name: "返回"
        },
        home: {
          className: "iconfont icon-zhuye",
          name: "主页"
        },
        mute: {
          className: "iconfont icon-jingyin",
          name: "静音"
        },

        /* 风扇 */
        anion: {
          className: "iconfont icon-fulizi",
          name: "负离子"
        },
        atomization: {
          className: "iconfont icon-quanwuhua",
          name: "雾化"
        },
        akey: {
          className: "iconfont icon-yijiantong",
          name: "一键通"
        },
        speed: {
          className: "iconfont icon-changhongfenglizidong",
          name: "风速"
        },
        putwind: {
          className: "iconfont icon-jiadiansaofeng",
          name: "摆风"
        },
        windClass: {
          className: "iconfont icon-fengshan",

          name: "风类"
        },
        /*机顶盒*/
        lookBack: {
          className: "iconfont icon-huikan1",

          name: "回看"
        }
        /*空调*/
      }
    };
  }
};



// WEBPACK FOOTER //
// ./src/items/iconButton.vue